import { Request, Response } from 'express';
import React, { useState, useEffect } from 'react';
import Sidebar from "../components/Sidebar";
import getUser from '../services/get-user';
import Button from "react-bootstrap/Button";
import axios from 'axios';
import AuthService from "../services/auth";
import UserService from '../services/user-service';
import { useHistory, useParams, useLocation } from "react-router-dom";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import "../styling/sidebar.css";
import Mode from '../components/Mode';
import ReactGA from "react-ga";


interface EtsyProps {
}

interface AccessProps {
  access_token: String;
}


const API_URL = 'https://sotira-back-test.herokuapp.com/';

//const API_URL = 'http://localhost:8080/';

export const Etsy: React.FC<EtsyProps> = ({}) => {
  const history = useHistory();
  const userID = getUser().userID;
  const [url, seturl] = useState('');
  const [sidebar, setSidebar] = useState(false);
  const [isLoading, setLoading] = useState(true);
  ReactGA.pageview(window.location.pathname);

  useEffect(() => {
    UserService.generateEtsyUrl().then(response=>{
      seturl(response.data.url);
      setLoading(false);
    });
  },[]);

  function componentMounted() {
    const currUser = AuthService.getCurrentUser();
    if (!currUser) {
      alert('could not find login token');
      history.push("/auth/login");
    }
  }
  componentMounted();

  if (isLoading) {
    return <div className="App">Loading...</div>;
  }
    return (
      <>
      <div>
      <Sidebar sidebar={sidebar} setSidebar={setSidebar} />
        <h1 className="etsytitle"> Etsy </h1>
        <div style={{textAlign:'center'}}>
          <h3> Connect your Etsy Shop </h3>
          <p> Connect your Etsy shop to your business to have all your past sales automatically inputted into your sales log </p>

          <a href={url}>

            <button className="etsybutton">
            Etsy - Connect to Etsy
            </button>
          </a>
        </div>
        <div className="etsytextcontainer">
          <p className="etsybottomtext"> The term 'Etsy' is a trademark of Etsy, Inc. This application uses the Etsy API but is not endorsed or certified by Etsy. </p>
        </div>
      </div>
      <Mode />
      </>
  );
}

const temp = {first_name: ""};
const temp2 = {shop_name: ""};

const temp3 = {count: 0, results: []};



export const Welcome: React.FC<AccessProps> = ({access_token}) => {
  const history = useHistory();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const accessToken = urlParams.get('access_token');
  const [sidebar, setSidebar] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [isLoading2, setLoading2] = useState(true);
  const [alldata, setAlldata] = useState(temp);
  const [shopData, setShopdata] = useState(temp2);
  const [ledgerData, setLedgerData] = useState(temp3);
  /*
  const [ledgerData, setLedgerData2] = useState(test_data);
  const [ledgerData1, setLedgerData] = useState(temp3);
  */
  const [source, setSource] = useState(0);

  const [nrows, setnRows] = useState([]);


  let change = 0;

  const handleExpOption = (event) => {
    console.log(event.target.value);
    setSource(event.target.value);
    if (change == 0) {
      change = 1;
    }
    change = change * -1;
  }

  useEffect(() => {
  try{
      UserService.addEtsyToken(accessToken).then(
        () => {
          //history.push(`http://localhost:3000/etsy/welcome?access_token=${tokenData.access_token}`);
        },
      )
    } catch(e: any){
      alert(e.message);
    }
    const userincome = UserService.getIncome().then(response3=>{
        const data=response3.data;
        setnRows(data.iname);
      });
  UserService.getEtsyData().then(response=>{
      setAlldata(response.data.data);
      //console.log(alldata);
      //console.log(response.data.data);
      setLoading(false);
  });
  UserService.getShopsData().then(response2=>{
      setShopdata(response2.data.shopData);
      //console.log(response2.data.shopData);
      setLedgerData(response2.data.data);
      //console.log(response2.data.shopData);
      console.log('Data Type');
      console.log(response2.data.data);
      setLoading2(false);
  });

  },[]);

  function componentMounted() {
    const currUser = AuthService.getCurrentUser();
    if (!currUser) {
      alert('could not find login token try using keep me signed in option');
      history.push("/auth/login");
    }
  }
  componentMounted();


  if (isLoading || isLoading2) {
    return <div className="App">Loading... if stuck reload page</div>;
  }
  // console.log(alldata);
  // console.log(shopData);
  //console.log(ledgerData);

  return (
    <>
    <div>
      {isLoading == false && <h1> Welcome, {alldata.first_name} </h1>}
      {isLoading2 == false && <h1> add shop {shopData.shop_name} to: </h1> }

      <FormControl sx={{ m: 1, width: 200, margin: 3 }} defaultValue={0}>
                        <InputLabel id="exp-source-option-label-etsy" className="etsylabel"> Source </InputLabel>
                        <Select
                          labelId="exp-source-option-label"
                          id="exp-source-option"
                          value={source}
                          onChange={handleExpOption}
                          label="Source"
                          autoWidth
                        >
                          <MenuItem
                            key="all"
                            value="0"
                            >
                             All Sources
                            </MenuItem>

                         {nrows.map((graph, index) => (

                           <MenuItem
                            key={graph}
                            value={index + 1}
                            >
                             {graph}
                            </MenuItem>
                         ))}

                        </Select>

                      </FormControl>
                      {(source == 0 || ledgerData.count == 0) &&
                        <button
                                className="etsybutton"
                                disabled
                              > Add Etsy Shop
                          </button>}
                      {source > 0 && ledgerData.count > 0 &&
                      <button
                              className="etsybutton"
                              onClick={() => {
                                try{
                                  //'http://localhost:3000/etsy/add_to_income'
                                  return axios.post(API_URL + 'etsy/add_to_income', {
                                  // return axios.post('https://sotira.herokuapp.com/etsy/add_to_income', {
                                    userID: getUser().userID,
                                    receipts: ledgerData,
                                    source: source
                                  }).then(response=>{window.location.reload()});
                                } catch(e: any){
                                  // alert(e.message);
                                }
                              }}
                            > Add Etsy Shop
                        </button>
                      }

                      {source > 0 && ledgerData.count > 30 &&
                      <button
                              className="etsybutton"
                              onClick={() => {
                                try{
                                  //'http://localhost:3000/etsy/add_to_income'
                                  return axios.post(API_URL + 'etsy/add_to_income', {
                                  // return axios.post('https://sotira.herokuapp.com/etsy/add_to_income', {
                                    userID: getUser().userID,
                                    receipts: {count: ledgerData['count'], results: ledgerData['results'].slice(0, 50) },
                                    source: source
                                  }).then(response=>{window.location.reload()});
                                } catch(e: any){
                                  // alert(e.message);
                                }
                              }}
                            > Add Etsy Shop (limit 30 up to 50) (click this if top button is not working);
                        </button>
                      }

            <div>
              <h3> Number of receipts: {ledgerData.count} </h3>
              <h3> Current Receipts: </h3>
              {ledgerData.count == 0 && ledgerData &&
              <ul>
                {ledgerData?.results.map((data: any) =>(
                  <div>
                  <li> Rec id: {data?.receipt_id} </li>
                  <li> Status: {data?.status} </li>
                  <li> Grand Total: {data?.grandtotal} </li>
                  </div>
                ))}
              </ul>
             }
             {ledgerData.count == 0 &&
               <p> No data was found </p>
             }
            </div>
    </div>
    <Mode />
    </>
  );
}
